<template>
  <div class="home-wrapper">
    <div class="d-flex mb-6 align-end" style="gap: 20px" v-if="userProfile">
      <h1>Hi {{ userProfile.first_name }}!</h1>
      <v-spacer></v-spacer>
      <v-select
        v-if="userProfile && accounts.length > 0"
        variant="solo"
        density="compact"
        flat
        hide-details=""
        style="max-width: 180px"
        v-model="period"
        bg-color="smoke"
        :items="periods"
        item-title="text"
        readonly=""
      ></v-select>
    </div>

    <skeleton-loader v-if="loading.general || loading.accounts" />

    <div v-else-if="userProfile">
      <div class="list" v-if="accounts.length > 0">
        <div class="account-row px-8">
          <p class="mb-0" style="font-size: 9pt">Account</p>
          <p class="mb-0" style="font-size: 9pt">Impressions</p>
          <p class="mb-0" style="font-size: 9pt">Engagements</p>
          <p class="mb-0" style="font-size: 9pt">Followers</p>
        </div>
        <div v-for="a in accounts" :key="a.id">
          <v-card
            :style="{
              borderBottom: '3px solid #272727',
              borderLeft: '1px solid #272727',
              borderTop: '1px solid #272727',
              borderRight: '3px solid #272727',
            }"
            class="account-row py-4 px-8 align-center"
            outlined
            flat
          >
            <div class="d-flex align-center" style="gap: 10px">
              <div style="position: relative" class="mr-2">
                <v-avatar
                  size="35"
                  :image="
                    a.profile_picture.src
                      ? a.profile_picture.src
                      : a.profile_picture
                  "
                ></v-avatar>
                <v-img
                  style="
                    border: 0.5px solid #fff;
                    border-radius: 50px;
                    top: -5px;
                    right: -10px;
                    position: absolute;
                  "
                  height="20"
                  width="20"
                  :src="require(`@/assets/${a.type}.png`)"
                ></v-img>
              </div>

              <p class="mb-0" style="font-weight: 400; font-size: 11pt">
                {{ a.name }}
              </p>
            </div>

            <div class="d-flex align-center" style="gap: 10px">
              <p
                class="mb-1"
                style="font-weight: 700; font-size: 14pt"
                v-if="a.analytics"
              >
                {{ a.analytics?.last_30_days?.impressions }}
              </p>
              <!-- <v-chip size="small" color="success">
                <p class="mb-0" style="font-weight: 500">+12</p>
              </v-chip> -->
            </div>

            <div class="d-flex align-center" style="gap: 10px">
              <p
                v-if="a.analytics?.last_30_days?.likes"
                class="mb-1"
                style="font-weight: 700; font-size: 14pt"
              >
                {{
                  a.analytics.last_30_days.likes +
                  a.analytics.last_30_days.comments +
                  a.analytics.last_30_days.clicks +
                  a.analytics.last_30_days.shares
                }}
              </p>
            </div>

            <div class="d-flex align-center" style="gap: 10px">
              <p
                v-if="a.analytics?.last_30_days?.followers"
                class="mb-1"
                style="font-weight: 700; font-size: 14pt"
              >
                {{ a.analytics.last_30_days.followers }}
              </p>
              <!-- <v-chip size="small" color="success">
                <p class="mb-0" style="font-weight: 500">+12</p>
              </v-chip> -->
            </div>

            <!-- <div class="d-flex align-end" style="gap: 10px">
              <v-btn @click="$router.push(`/accounts?edit=${a.id}`)" icon>
                <v-icon color="primary" size="small">mdi-pencil</v-icon>
              </v-btn>
              <v-btn @click="open(a.url)" icon>
                <v-icon color="primary" size="small">mdi-open-in-new</v-icon>
              </v-btn>
            </div> -->
          </v-card>
        </div>
      </div>
    </div>

    <div
      class="d-flex flex-column"
      style="gap: 10px"
      v-if="onboardingIncomplete.total && !loading.general && !loading.accounts"
    >
      <div class="d-flex align-center mb-2 mt-6">
        <h2 style="width: 320px">Complete your onboarding</h2>
        <v-divider></v-divider>
      </div>
      <v-card
        v-if="onboardingIncomplete.accounts"
        flat
        class="pa-4 d-flex justify-space-between align-center"
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <div>
          <h3>Accounts</h3>
          <p style="font-size: 10pt">
            Start by connecting your Linkedin accounts to your workspace.
          </p>
        </div>
        <v-btn
          @click="$router.push('/settings/accounts')"
          variant="flat"
          color="accent"
          size="small"
          append-icon="mdi-arrow-right"
          >Link my accounts</v-btn
        >
      </v-card>

      <v-card
        v-if="onboardingIncomplete.categories"
        flat
        class="pa-4 d-flex justify-space-between align-center"
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <div>
          <h3>Categories</h3>
          <p style="font-size: 10pt">Start by setting up your categories.</p>
        </div>
        <v-btn
          @click="$router.push('/categories')"
          variant="flat"
          color="accent"
          size="small"
          append-icon="mdi-arrow-right"
          >Create categories</v-btn
        >
      </v-card>

      <v-card
        v-if="onboardingIncomplete.posts"
        flat
        class="pa-4 d-flex justify-space-between align-center"
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <div>
          <h3>Posts</h3>
          <p style="font-size: 10pt">
            Import your evergreen posts or create new ones.
          </p>
        </div>
        <div class="d-flex" style="gap: 10px">
          <v-btn
            @click="$router.push('/feed')"
            variant="flat"
            color="accent"
            size="small"
            v-if="accounts.length > 0"
            append-icon="mdi-arrow-right"
            >Import posts</v-btn
          >
          <v-btn
            @click="$router.push('/post')"
            variant="flat"
            color="accent"
            size="small"
            append-icon="mdi-arrow-right"
            >Create new post</v-btn
          >
        </div>
      </v-card>

      <v-card
        v-if="onboardingIncomplete.schedules"
        flat
        class="pa-4 d-flex justify-space-between align-center"
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <div>
          <h3>Schedules</h3>
          <p style="font-size: 10pt">
            Add your first schedule to your categories.
          </p>
        </div>
        <div class="d-flex" style="gap: 10px">
          <v-btn
            @click="$router.push('/schedule')"
            variant="flat"
            color="accent"
            size="small"
            append-icon="mdi-arrow-right"
            >Create schedule</v-btn
          >
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import skeletonLoader from "./skeletonLoader.vue";
export default {
  components: {
    skeletonLoader,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      accounts: (state) => state.accounts.accounts,
      articles: (state) => state.admin.articles,
      schedules: (state) => state.schedules.schedules,
      posts: (state) => state.posts.posts,
      categories: (state) => state.posts.categories,
    }),
    onboardingIncomplete() {
      return {
        accounts: this.accounts.length === 0,
        categories: this.categories.length === 0,
        posts: this.posts.length === 0,
        schedules: this.schedules.length === 0,
        total:
          this.accounts.length === 0 ||
          this.categories.length === 0 ||
          this.posts.length === 0 ||
          this.schedules.length === 0,
      };
    },
    impressions() {
      let impressions = {
        today: 0,
        last_1d: 0,
        last_7d: 0,
        last_14d: 0,
        last_30d: 0,
      };

      this.accounts.forEach((a) => {
        if (a.insights) {
          impressions.today = impressions.today + a.insights.impressions.today;
          impressions.last_1d =
            impressions.last_1d + a.insights.impressions.last_1d;
          impressions.last_7d =
            impressions.last_7d + a.insights.impressions.last_7d;
          impressions.last_14d =
            impressions.last_14d + a.insights.impressions.last_14d;
          impressions.last_30d =
            impressions.last_30d + a.insights.impressions.last_30d;
        }
      });
      return impressions;
    },
    engagements() {
      let engagements = {
        today: 0,
        last_1d: 0,
        last_7d: 0,
        last_14d: 0,
        last_30d: 0,
      };

      this.accounts.forEach((a) => {
        if (a.insights) {
          engagements.today = engagements.today + a.insights.engagements.today;
          engagements.last_1d =
            engagements.last_1d + a.insights.engagements.last_1d;
          engagements.last_7d =
            engagements.last_7d + a.insights.engagements.last_7d;
          engagements.last_14d =
            engagements.last_14d + a.insights.engagements.last_14d;
          engagements.last_30d =
            engagements.last_30d + a.insights.engagements.last_30d;
        }
      });
      return engagements;
    },
    followers() {
      let followers = {
        today: 0,
        last_1d: 0,
        last_7d: 0,
        last_14d: 0,
        last_30d: 0,
      };

      this.accounts.forEach((a) => {
        if (a.insights) {
          followers.today = followers.today + a.insights.followers.today;
          followers.last_1d = followers.last_1d + a.insights.followers.last_1d;
          followers.last_7d = followers.last_7d + a.insights.followers.last_7d;
          followers.last_14d =
            followers.last_14d + a.insights.followers.last_14d;
          followers.last_30d =
            followers.last_30d + a.insights.followers.last_30d;
        }
      });
      return followers;
    },
  },
  data: () => ({
    account: "all accounts",
    account_items: ["all accounts"],
    dashboard_items: [],
    panel: [],
    headers: [
      {
        text: "Title",
        align: "start",
        sortable: false,
        value: "title",
      },
      { text: "", value: "actions", align: "end" },
    ],
    periods: [
      {
        text: "Yesterday",
        value: "last_1d",
      },
      {
        text: "Last week",
        value: "last_7d",
      },
      {
        text: "Two weeks",
        value: "last_14d",
      },
      {
        text: "30 days",
        value: "last_30d",
      },
    ],
    period: "last_30d",
    time: "today",
    time_items: ["today", "this week", "this month"],
  }),
  methods: {
    open(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./styles.scss";
</style>
